module.exports = __webpack_public_path__ + "files/f0201fba8db2d65a15c61f6fea9b76d6.png";